import {HeaderElement, HeaderElementType } from "src/types";

const resourcesHeader = {
  title: 'Resources',
  redirectLink: '',
  actionType: HeaderElementType.DRPODOWN,
  dropdown: [
    {
      title: 'Request Form',
      redirectLink: '/assets/completed-request-v2.pdf',
    },
    {
      title: 'Basics of Reimbursement',
      redirectLink:'/assets/reimbursement-basics.pdf'
    },
    {
      title: 'EUFLEXXA Reimbursement in the Physician Office',
      redirectLink:'/assets/do-reimbursement.pdf'
    },
    {
      title: 'EUFLEXXA Benefit Verification and Prior Authorization Checklist',
      redirectLink:'/assets/bv-pa-checklist.pdf'
    },
    {
      title: 'EUFLEXXA Public and Private Payer Coverage Information',
      redirectLink:'/assets/payer-coverage.pdf'
    },
    {
      title:'Schedule a Rep Visit',
      redirectLink:'https://hcp.euflexxa.com/get-euflexxa/'
    },
    {
      title:'HCP Website',
      redirectLink:'https://hcp.euflexxa.com/'

    },{
      title:'Patient Website',
      redirectLink:'https://www.euflexxa.com/'

    },
  ]
};

const videosHeader = {
  title: 'Videos',
  redirectLink: '',
  actionType: HeaderElementType.DRPODOWN,
  dropdown: [
    {
      title: 'Welcome Video',
      redirectLink: '/assets/welcome.mp4',
    },
    {
      title: 'How to Read Benefits Video',
      redirectLink:'/assets/benefits.mp4'
    },
    {
      title: 'Transfers Tutorial Video',
      redirectLink:'/assets/transfers.mp4'
    },
    {
      title: 'PA Tutorial Video',
      redirectLink:'/assets/pa.mp4'
    },
    {
      title: 'Retreatments Tutorial Video',
      redirectLink:'/assets/retreatments.mp4'
    },
  ]
};

export const PublicHeader: HeaderElement[] = [
  {
    title: 'Welcome',
    redirectLink: '/users/sign_in',
    actionType: HeaderElementType.ROUTE,
  },
  // {
  //   title: 'Enrollment',
  //   redirectLink: '/enrollments/new',
  //   actionType: HeaderElementType.ROUTE,
  // },
  {
    title: 'Request Form',
    redirectLink: '/assets/completed-request-v2.pdf',
    actionType: HeaderElementType.LINK,
  },
];

export const AuthenticatedManufactureHeader: HeaderElement[] = [
  {} as unknown as HeaderElement,
  {} as unknown as HeaderElement,
  {
    ...resourcesHeader,
    dropdown: resourcesHeader.dropdown.filter(
        (item) => item.title !== 'Schedule a Rep Visit'
    ),
  },
  videosHeader
];
export const AuthenticatedHCPHeader: HeaderElement[] = [
  
  {
    title: 'Cases',
    redirectLink: '/cases',
    actionType: HeaderElementType.ROUTE,
  },
  {
    title: 'Submit a Request',
    redirectLink: '/cases/new',
    actionType: HeaderElementType.ROUTE,
  },
  {
    title: 'Retreatment Requests',
    redirectLink: '/retreatments',
    actionType: HeaderElementType.ROUTE,
  },
  resourcesHeader,
  videosHeader
  
];


